// Tells the presence room where I am in words ("SH010", "Episode 1", "Elements"), so the others can show
// "Viewing: …" and the top bar can say where someone is, and lets following resolve a scene's episode.
import { useEffect } from "react";
import type { Folder } from "../folders.ts";
import { crumbsFor } from "../items.ts";
import { findShot } from "../looseShot.ts";
import type { Route } from "../route.ts";
import type { ProjectData } from "../useProject.ts";
import { useCollab } from "./CollabProvider.tsx";

export function whereLabel(
  d: ProjectData | null,
  route: Route,
  folders: readonly Folder[],
): string | undefined {
  if (!d) return undefined;
  if (route.view === "shot") return findShot(d, route.shotId)?.code;
  if (route.view === "element") return d.elements.find((e) => e.id === route.elementId)?.name;
  if (route.view !== "project") return undefined;
  const crumbs = crumbsFor(d, route.loc, folders);
  return crumbs[crumbs.length - 1]?.label;
}

export function useWhereLabel(d: ProjectData | null, route: Route, folders: readonly Folder[]): void {
  const c = useCollab();
  const label = whereLabel(d, route, folders);
  const setLabel = c?.setWhereLabel;
  useEffect(() => {
    setLabel?.(label);
  }, [setLabel, label]);
  const setResolver = c?.setResolver;
  useEffect(() => {
    if (!d || !setResolver) return;
    setResolver({
      episodeOfScene: (sceneId) => {
        for (const [ep, list] of d.scenes) if (list.some((s) => s.id === sceneId)) return ep;
        return undefined;
      },
    });
  }, [d, setResolver]);
}
